import { IconButton, Tooltip } from "@mui/material";

export default function ToolBarButton({
  tooltip,
  icon,
  onClick,
  onRef = null,
  disabled,
}) {
  // Span wrapper so the tooltip still shows while the button is disabled.
  const button = (
    <span ref={(r) => r && onRef && onRef(r)} style={{ display: "inline-flex" }}>
      <IconButton
        size="large"
        onClick={(e) => !disabled && onClick(e)}
        disabled={disabled}
      >
        {icon}
      </IconButton>
    </span>
  );

  return tooltip ? (
    <Tooltip title={tooltip} placement="bottom">
      {button}
    </Tooltip>
  ) : (
    button
  );
}
